import { Navigate, useParams } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import { SEOHead } from '@/components/SEOHead';

const LEGACY_LANGS = ['en', 'sv', 'de', 'fr', 'es', 'pt'];

export const RedirectLegacyArticle = () => {
  const { lang, slug } = useParams();
  if (!lang || !LEGACY_LANGS.includes(lang)) return <NotFound />;
  const target = `/article/${slug}`;
  return (
    <>
      <SEOHead title="Redirecting" description="This page has moved." path={target} robots="noindex, follow" />
      <Navigate to={target} replace />
    </>
  );
};

export const RedirectLegacyCategory = () => {
  const { lang, categoryId } = useParams();
  if (!lang || !LEGACY_LANGS.includes(lang)) return <NotFound />;
  const target = `/category/${categoryId}`;
  return (
    <>
      <SEOHead title="Redirecting" description="This page has moved." path={target} robots="noindex, follow" />
      <Navigate to={target} replace />
    </>
  );
};

export const RedirectLegacyHome = () => {
  const { lang, '*': rest } = useParams();
  if (!lang || !LEGACY_LANGS.includes(lang)) return <NotFound />;
  const target = rest ? `/${rest}` : '/';
  return (
    <>
      <SEOHead title="Redirecting" description="This page has moved." path={target} robots="noindex, follow" />
      <Navigate to={target} replace />
    </>
  );
};
